import COLORS from '../../shared/colors'
DEFAULT_COLOR = 'silver'

export default extractColor = (key)->
	color = COLORS.all.find(value:key) or COLORS.all.find(value:DEFAULT_COLOR)
	{gradient, direction, color} = color

	return {gradient, direction, color}